import { PreferenceSet } from '@knocklabs/client'

export const SLACK_OAUTH_SOURCE = 'slack-oauth'

export enum NotificationTab {
  THIRD_PARTY = 'Third-party',
  ORGANIZATION = 'Organization',
  PERSONAL = 'Personal',
}

export interface FormState {
  dueDateReminderEnabled: boolean
  cadenceInterval: string
  ccBusinessOwnerEnabled: boolean
  isSubscribed: boolean
  preferences: PreferenceSet
}

export type OAuthResultMessage = {
  source: typeof SLACK_OAUTH_SOURCE
  status: 'success' | 'error'
  message: string
}
